
<template>
  <div class="picturs-nav">
    <div class="upic-nav" v-for="(item, i) in attachments" :key="'item' + i">
      <img class="upic-img" :src="item.src" alt=""/>
      <div class="upic-action-nav" @click="$emit('click',i)">
        <span @click="(event)=>{$emit('show',i);event.stopPropagation();}">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke="#ffffffe8"
          >
            <rect x="3" y="3" width="18" height="18" rx="2" ry="2"></rect>
            <circle cx="8.5" cy="8.5" r="1.5"></circle>
            <polyline points="21 15 16 10 5 21"></polyline>
          </svg>
        </span>
        <span @click="(event)=>{$emit('remove',i);event.stopPropagation();}" v-show="showRemoveBtn">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            stroke="#ffffffe8"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
            class="feather feather-x"
          >
            <line x1="18" y1="6" x2="6" y2="18"></line>
            <line x1="6" y1="6" x2="18" y2="18"></line>
          </svg>
        </span>
      </div>
    </div>
    <div class="upic-nav">
      <div class="upic-empty" @click="browse">
        <span>{{ defaultText }}</span>
      </div>
      <input
        type="file"
        ref="file1"
        style="display: none"
        @change="change"
        :accept="accept"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: "",
  props: {
    accept: {
      type: String,
      default: "image/jpeg,image/png,image/jpg,application/pdf",
    },
    defaultText: {
      type: String,
      default: "آپلود",
    },
    attachments: {
      default: [],
    },
    showRemoveBtn: {
      type: Boolean,
      default: true,
    },
  },
  components: {},
  data() {
    return {};
  },
  watch: {},
  computed: {},
  methods: {
    browse() {
      this.$refs.file1.click();
    },
    change(input) {
      if (input.target.files && input.target.files[0]) {
        var reader = new FileReader();
        reader.onload = (e) => {
          //this.attachments.push({src:e.target.result});
        };

        reader.readAsDataURL(input.target.files[0]);
        this.$emit("change", input);
      }
    },
  },
  mounted() {},
};
</script>

<style lang="scss">
.picturs-nav{
  display: flex;
  flex-direction: row;
}
.upic-nav {
  position: relative;
  margin: 4px;
  background-color: #f1f1f1;
  height: 165px;
  width: 165px;
  .upic-img {
    width: 100%;
    height: 100%;
  }
}
.upic-empty {
  cursor: pointer;
  display: inline-table;
  width: 90%;
  margin: 5%;
  height: 90%;
  border: 2px dashed rgba(66, 66, 66, 0.15);
  span {
    text-align: center;
    display: table-cell;
    vertical-align: middle;
    font-size: 1.1em;
  }
}
.upic-action-nav {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 10;
  display: flex;
  justify-content: center;
  align-items: center;
  span {
    margin: 7px;
    border: 2px solid #ffffffe8;
    background-color: #00000082;
    box-shadow: 0px 0px 5px #1111119e;
    border-radius: 100%;
    width: 40px;
    height: 40px;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    transition-duration: 0.2s;
    &:hover {
      transform: scale(1.12);
    }
  }
}
</style>